<template>
  <div class="feedback-link">
    <ELink
      as="button"
      type="button"
      color="secondary"
      v-bind="$attrs"
      tabindex="0"
      data-test-id="feedback-link"
      :aria-pressed="!!modalActive"
      @click="onClick"
      @keydown.enter="onClick"
      @keydown.space="onClick"
      v-on="$listeners"
    >
      <slot />
    </ELink>
    <EFeedbackModal v-bind="$props" :active="modalActive" @close="onClose" />
  </div>
</template>

<script>
import ELink from '~~/common/vue/components/link';
import EFeedbackModal from '~~/common/vue/components/feedback-modal';

export default {
  name: 'EFeedbackLink',
  components: {
    ELink,
    EFeedbackModal,
  },
  props: {
    ...EFeedbackModal.props,
  },
  data() {
    return {
      modalActive: false,
    };
  },
  methods: {
    onClick() {
      this.modalActive = true;
    },
    onClose() {
      this.modalActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-link {
  white-space: nowrap;
}
</style>
